<script setup lang="ts">
import type { ICredit } from '~/components/entity/credit'

const { credit } = defineProps<{ credit: ICredit }>()
const { t } = useI18n()

const relevantOptions = [
  { name: 'passport_required', text: t('widget.credit_page.specifications.passport_required') },
  {
    name: 'guarantee_required',
    text: t('widget.credit_page.specifications.guarantor_required')
  },
  {
    name: 'initial_fee_required',
    text: t('widget.credit_page.specifications.initial_payment_required')
  },
  {
    name: 'commission_fee_required',
    text: t('widget.credit_page.specifications.processing_fee_required')
  },
  {
    name: 'income_confirmation',
    text: t('widget.credit_page.specifications.income_confirmation')
  },
  { name: 'collateral', text: t('widget.credit_page.specifications.collateral') }
] as const

const activeOptions = computed(() =>
  relevantOptions
    .filter((option) => credit[option.name])
    .map((option) => ({ ...option, icon: 'newspaper' }))
)
</script>

<template>
  <div class="grid grid-cols-1 gap-5 md:grid-cols-3">
    <div
      v-for="item in activeOptions"
      :key="item.name"
      class="flex items-center gap-2 rounded-md bg-gray-100 p-4"
    >
      <div class="rounded-md bg-white p-2"><UiIcon :name="item.icon" /></div>
      <div class="text-sm">
        {{ item.text }}
      </div>
    </div>
  </div>
</template>
